/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import FullPageModal from 'app/components/common/FullPageModal.jsx';
import DateDisplay from 'app/components/common/DateDisplay.jsx';
import * as _ from 'underscore';

class DowngradeModal extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            limits: {},
            cancellationStep: 1
        };

        this.redirectToAutomate = this.redirectToAutomate.bind(this);
        this.cleanDowngrade = this.cleanDowngrade.bind(this);
        this.killSwitch = this.killSwitch.bind(this);
        this.checkDowngradeEligibility = this.checkDowngradeEligibility.bind(this);

    }

    componentDidMount() {

        this.props.limitCheck(this.props.newPlanLevel, this.props.addOnQuantity);

        if (dataLayer) {
            dataLayer.push({
                'event': 'checkout',
                'ecommerce': {
                    'checkout': {
                        'actionField': {'step': 2, 'option': 'Downgrade'}
                    }
                }
            });
        }

    }

    redirectToAutomate(e) {

        e.preventDefault();
        this.props.router.navigate('/share/automate');
        this.props.closeAllModals();

    }

    cleanDowngrade(e) {

        let data = {
            level: this.props.newPlanLevel,
            term: this.props.newPlanTerm,
            trackingAction: 'downgrade'
        };

        e.preventDefault();

        if (this.props.adjustedAddOns) {
            data.add_on_social = this.props.adjustedAddOns;
        }

        this.setState({
            processing: true
        });

        this.props.planChangeHandler(data);

    }

    killSwitch(e) {

        e.preventDefault();

        this.setState({
            processing: true
        });

        this.props.planChangeHandler({
            level: this.props.newPlanLevel,
            term: this.props.newPlanTerm,
            isHammertime: true,
            trackingAction: 'downgrade'
        });

    }

    checkDowngradeEligibility() {
        let downgradeBlockers = {},
            constants = this.props.app.config.constants,
            inputsInUse = this.props.plans.limitCheck.totalInputs - this.props.plans.limitCheck.inputs,
            outputsInUse = this.props.plans.limitCheck.totalOutputs - this.props.plans.limitCheck.outputs;

        if (this.props.isFreeUser(this.props.newPlanLevel)) {
            return downgradeBlockers;
        }

        if (this.props.isPlusUser() || this.props.isAgencyPlusUser()) {
            if (!this.props.plans.limitCheck.everqueue) {
                downgradeBlockers.everqueue = true;
            }
            if (!this.props.plans.limitCheck.bulkImport) {
                downgradeBlockers.bulkImport = true;
            }
            if (!this.props.plans.limitCheck.categories) {
                downgradeBlockers.categories = true;
            }
        }

        if (this.props.plans.limitCheck.inputs < 0) {
            downgradeBlockers.inputs = parseInt(this.props.user.perms.perms.hardLimitInputs, 10) - parseInt(this.props.user.perms.resources.inputsAvailable);
        }

        if (this.props.plans.limitCheck.outputs < 0) {
            downgradeBlockers.outputs = parseInt(this.props.user.perms.perms.hardLimitOutputs, 10) - parseInt(this.props.user.perms.resources.outputsAvailable);
        }

        if (this.props.plans.limitCheck.multiAvailable === 0 && this.props.plans.limitCheck.multiSafe === false) {
            downgradeBlockers.multi = true;
        }

        // if (this.props.plans.limitCheck.pinterestInputEnabled === 0 && parseInt(this.props.plans.limitCheck.pinterestOutput, 10) > 0) {
        //     downgradeBlockers.pinterestOutput = true;
        // }

        if (this.props.plans.limitCheck.twitterInputEnabled === 0 && parseInt(this.props.plans.limitCheck.twitterInput, 10) > 0) {
            downgradeBlockers.twitterInput = true;
        }

        if (this.props.plans.limitCheck.usersAvailable < this.props.plans.limitCheck.userCount) {
            downgradeBlockers.extraSeats = true;
        }

        if (!this.props.plans.limitCheck.hashStatic && this.props.plans.limitCheck.hashStaticUsed) {
            downgradeBlockers.hashStatic = true;
        }

        if (!this.props.plans.limitCheck.hashPool && this.props.plans.limitCheck.hashPoolUsed) {
            downgradeBlockers.hashPool = true;
        }

        if (!this.props.plans.limitCheck.autoHash && this.props.plans.limitCheck.autoHashUsed) {
            downgradeBlockers.autoHash = true;
        }

        if (!this.props.plans.limitCheck.feedPush && this.props.plans.limitCheck.feedPushUsed) {
            downgradeBlockers.feedPush = true;
        }

        return downgradeBlockers;

    }

    render() {

        let downgradeBlock = null,
            downgradeBlockers = {},
            inputBlocker = null,
            outputBlocker = null,
            multiBlocker = null,
            pinterestBlocker = null,
            twitterBlocker = null,
            userBlocker = null,
            everqueueBlocker = null,
            categoryBlocker = null,
            importBlocker = null,
            staticHashBlocker = null,
            hashPoolBlocker = null,
            autoHashBlocker = null,
            feedPushBlocker = null,
            content = null,
            buttonLabel = '',
            constants = this.props.app.config.constants,
            downgradeContent = null,
            explanationClass = 'downgrade-explanation',
            now = new Date(),
            trialEnd = now,
            modalTitle = "Plan Change";

        if (_.isEmpty(this.props.plans.limitCheck)) {
            return null;
        }

        if (this.props.user && this.props.user.plan.trialEndsAt) {
            trialEnd = new Date(this.props.user.trialEndsAt);
        }

        downgradeBlockers = this.checkDowngradeEligibility();

        if (_.isEmpty(downgradeBlockers)) {
            buttonLabel = (this.state.processing) ? (<i className="fa fa-spinner fa-pulse"></i>) : 'Continue';
            if (this.props.isFreeUser(this.props.newPlanLevel)) {
                modalTitle = "Plan Cancellation";
                if (this.state.cancellationStep === 1) {
                    content = (
                        <div className="downgrade-block">
                            <div className="downgrade-explanation solo cancel">
                                {"Ending your dlvr.it plan will stop all posting to your social media platforms."}
                            </div>
                            <div className="downgrade-explanation solo cancel">
                                {"Do you want to keep posting to social media?"}
                            </div>
                            <div className="continue-downgrade solo cancel">
                                <button className="btn-primary fixed active upgrade-subscription" onClick={(e) => {
                                    this.props.closeAllModals();
                                }}>Yes! Continue posting.</button>
                                <a href="#" onClick={(e) => {
                                    this.setState({
                                        cancellationStep: 2
                                    });
                                }}>No. Cancel plan and stop posting.</a>
                            </div>
                        </div>
                    )
                } else if (this.state.cancellationStep === 2) {
                    content = (
                        <div className="downgrade-block">
                            <div className="downgrade-explanation solo cancel">
                                {"We understand your needs change."}<br/>{"Your plan will end and all posting will stop on "} <DateDisplay dateTime={this.props.user.plan.nextBilling} user={this.props.user}/>.
                            </div>
                            <div className="continue-downgrade solo cancel">
                                <button className="btn-primary fixed active upgrade-subscription" onClick={this.cleanDowngrade}>Confirm Cancellation</button>
                            </div>
                        </div>
                    );
                }
                
            } else {
                content = (
                    <div className="downgrade-block">
                        <div className="downgrade-explanation solo">
                            {"We understand that your needs change. If you need to ramp up your sharing again, we'll have you covered."}
                        </div>
                        <div className="continue-downgrade solo">
                            <button className="btn-primary fixed active upgrade-subscription" onClick={this.cleanDowngrade}>{buttonLabel}</button>
                        </div>
                    </div>
                );
            }

        } else if (!_.isEmpty(downgradeBlockers) && now < trialEnd) {
            buttonLabel = (this.state.processing) ? (<i className="fa fa-spinner fa-pulse"></i>) : 'Continue';
            content = (
                <div className="downgrade-block">
                    <div className="downgrade-explanation solo">
                        {"We understand that your needs change. If you need to ramp up your sharing again, we'll have you covered."}
                    </div>
                    <div className="downgrade-explanation solo">
                        {"You'll be able to continue using your plan until your trial expires on "} <DateDisplay dateTime={this.props.user.plan.nextBilling} user={this.props.user}/>
                    </div>
                    <div className="continue-downgrade solo">
                        <button className="btn-primary fixed active" onClick={this.cleanDowngrade}>{buttonLabel}</button>
                    </div>
                </div>
            );
        } else {
            if (downgradeBlockers.inputs) {
                inputBlocker = <li>You have {downgradeBlockers.inputs} inputs, the new plan supports {this.props.plans.limitCheck.totalInputs}.</li>;
            }
            if (downgradeBlockers.outputs) {
                outputBlocker = <li>You have {downgradeBlockers.outputs} outputs, the new plan supports {this.props.plans.limitCheck.totalOutputs}.</li>;
            }
            if (downgradeBlockers.multi) {
                multiBlocker = <li>The new plan only supports one social account of each type.</li>;
            }
            // if (downgradeBlockers.pinterestOutput) {
            //     pinterestBlocker = <li>Pinterest outputs aren't available in the new plan.</li>;
            // }
            if (downgradeBlockers.twitterInput) {
                twitterBlocker = <li>Twitter inputs aren't available in the new plan.</li>;
            }
            if (downgradeBlockers.extraSeats) {
                userBlocker = <li>You have {this.props.plans.limitCheck.userCount} additional users. The new plan provides {this.props.plans.limitCheck.usersAvailable}.</li>;
            }
            if (downgradeBlockers.everqueue) {
                everqueueBlocker = <li>You'll lose access to your EverQueue content and they'll no longer post.</li>
            }
            if (downgradeBlockers.bulkImport) {
                importBlocker = <li>Searching and importing content to your social queues and EverQueues will not be available.</li>
            }
            if (downgradeBlockers.categories) {
                categoryBlocker = <li>You'll no longer be able to categorize your content, and any category schedules will not post.</li>
            }
            if (downgradeBlockers.hashStatic) {
                staticHashBlocker = <li>Fixed hashtags will not post.</li>
            }
            if (downgradeBlockers.hashPool) {
                hashPoolBlocker = <li>Dynamic Hashtags will be deactivated.</li>
            }
            if (downgradeBlockers.autoHash) {
                autoHashBlocker = <li>Auto Detected Hashtags will be deactivated.</li>
            }
            if (downgradeBlockers.feedPush) {
                feedPushBlocker = <li>PuSH feeds will no longer update in real-time.</li>
            }
            buttonLabel = (this.state.processing) ? (<i className="fa fa-spinner fa-pulse"></i>) : 'Deactivate All';

            if (this.props.isFreeUser(this.props.newPlanLevel)) {
                explanationClass += " solo";
                downgradeContent = (
                    <div>
                        <div className="downgrade-warning-block">
                            Before <DateDisplay dateTime={this.props.user.plan.nextBilling} user={this.props.user} dateTimeFormat="human"/> you'll need to deactivate all of the features listed above. If you fail to do so ALL feeds and socials will stop posting and will immediately be deactivated.
                        </div>
                        <div className="downgrade-buttons">
                            <div className="downgrade-continue-button" onClick={this.cleanDowngrade} role="button" aria-label="downgrade plan">
                                Downgrade plan
                            </div>
                            <div className="downgrade-cancel-button" onClick={this.props.closeAllModals} role="button" aria-label="stay put">
                                Stay on current plan
                            </div>
                        </div>
                    </div>
                );
            } else {
                downgradeContent = (
                    <div>
                        <div className="continue-downgrade">
                            Immediately deactivate ALL feeds and socials and stop all posting. <button className="btn-secondary fixed active" onClick={this.killSwitch}>{buttonLabel}</button>
                        </div>
                        <div className="choice-block">
                            <div className="divider"></div>
                            <div className="choice">or</div>
                        </div>
                        <div className="cancel-downgrade">
                            Go back and selectively deactivate feeds and socials before changing plans. <button className="btn-primary fixed active" onClick={this.redirectToAutomate}>Go Back</button>
                        </div>
                    </div>
                );
            }

            content = (
                <div className="downgrade-block">
                    <h3>Important!</h3>
                    <div className={explanationClass}>
                        {"Your chosen plan does not support the following active features:"}
                        <ul className="downgrade-blockers">
                            {inputBlocker}
                            {outputBlocker}
                            {everqueueBlocker}
                            {importBlocker}
                            {categoryBlocker}
                            {multiBlocker}
                            {pinterestBlocker}
                            {twitterBlocker}
                            {userBlocker}
                            {staticHashBlocker}
                            {hashPoolBlocker}
                            {autoHashBlocker}
                            {feedPushBlocker}
                        </ul>
                    </div>
                    {downgradeContent}
                </div>
            );
        }

        downgradeBlock = (
            <FullPageModal
                title={modalTitle}
                content={content}
                closeAction={this.props.closeAllModals} />
        );

        return downgradeBlock;
    }

};

DowngradeModal.displayName = "DowngradeModal";

DowngradeModal.propTypes = {
    newPlanLevel: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    addOnQuantity: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    planChangeHandler: PropTypes.func
};

DowngradeModal.defaultProps = {
    newPlanLevel: 0,
    newPlanTerm: 0,
    addOnQuantity: 0,
    router: null,
    planChangeHandler: null,
    processing: false
};

export default DowngradeModal;
